import axios from "axios"
import { json } from "react-router-dom"

export const show = async ({ params }) => {
    return axios.get(`${process.env.REACT_APP_INVENTORY_API_URL}/satuan/${params.id}`, { params: { with_base: 1 } })
        .then((res) => res.data.data)
        .catch((error) => {
            throw new json(error, error.response.status)
        })
}
